<div class="blog-promo-preview-container">
  <app-blog-promo-section 
    [apiKey]="apiKey" 
    [entryName]="entryName">
  </app-blog-promo-section>
</div>

